export default {
  TRANSLATOR_PROJECTS: 'Translator Projects',
  PRIORITY_PROJECTS: 'Priority Projects',
  REVIEWS_PROJECTS: 'Reviews',
  LL_PROJECTS: 'LL Projects',
  REVIEWED_BY_QA_LL: 'Reviewed by QA/LL',
};
